import { Box, Text } from '@wix/design-system';
import React from 'react';
import { RunTaskEntryStatus } from '../../constants';
import { useTranslation } from '../../hooks';
import { StatusIcon } from './StatusIcon';
export const TriggeredStatus = () => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    backgroundColor: "G60",
    padding: "SP1 SP2",
    gap: "SP1",
    borderRadius: 4
  }, /*#__PURE__*/React.createElement(StatusIcon, {
    status: RunTaskEntryStatus.Succeeded
  }), /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, t('trigger.status.message')));
};
//# sourceMappingURL=TriggeredStatus.js.map